import { gql } from '@apollo/client';

export const CREATE_MODE = gql`
  mutation CreateMode($record: CreateReservationModeInput!) {
    schedule {
      createReservationMode(record: $record) {
        ok
        error {
          message
          code
        }
        resultId
        result {
          id
          name
          duration
        }
      }
    }
  }
`;
